import { render, staticRenderFns } from "./ListaInstrumento.vue?vue&type=template&id=6ceabaff&"
import script from "./ListaInstrumento.vue?vue&type=script&lang=js&"
export * from "./ListaInstrumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports